<template>
    <div id='plugin' v-if="isAdmin()" style='height: 50vh;'>
 

        <h1>Plug-in Js </h1>
        <h2>(Interface de correction)</h2>

        <ul class="plugin_title">
            <!-- le nouveau en premier !-->
            <li><a class="lienActif" href="https://www.prolexis.com/DIAGONAL/WebServicePlugin/InterfaceCorrectionWeb_4.1.2.zip" target="_blank" rel="noopener noreferrer">4.1.2</a> (version du 21/10/2026) <span @click='toggleLog(6)'><i class="material-icons pluginfo">info_outline</i></span>
                <ul class="plugin_log" v-if="showLog[6]">
                    <li>Correction bug graphique lorsque l'application hôte utilise un scroll-padding personnalisé.</li>
                </ul>
            </li>
            <li><a class="lienActif" href="https://www.prolexis.com/DIAGONAL/WebServicePlugin/InterfaceCorrectionWeb_4.1.1.zip" target="_blank" rel="noopener noreferrer">4.1.1</a> (version du 14-10-2026) <span @click='toggleLog(5)'><i class="material-icons pluginfo">info_outline</i></span>
                <ul class="plugin_log" v-if="showLog[5]">
                    <li>Ajout compatibilité iframe cross-origin.</li>
                    <li>Ajout d'un plugin pour CKEditor 5 v42 et suivants.</li>
                    <li>Ajout aux plugins CKEditor 5 d'options équivalentes à celles de DiagPlWs.init.</li>
                </ul>
            </li>
            <li><a class="lienActif" href="https://www.prolexis.com/DIAGONAL/WebServicePlugin/InterfaceCorrectionWeb_4.1.0.zip" target="_blank" rel="noopener noreferrer">4.1</a> (version du 08-06-2026) <span @click='toggleLog(4)'><i class="material-icons pluginfo">info_outline</i></span>
                <ul class="plugin_log" v-if="showLog[4]">
                    <li>Amélioration du comportement de la fontionnalité « ignorer multiple »</li>
                    <li>Ajout de fonction permettant d’obtenir le numéro de version</li>
                </ul>
            </li>
            <li><a class="lienActif" href="https://www.prolexis.com/DIAGONAL/WebServicePlugin/InterfaceCorrectionWeb_4.0.9.zip" target="_blank" rel="noopener noreferrer">4.09</a> (version du 17-02-2026) <span @click='toggleLog(3)'><i class="material-icons pluginfo">info_outline</i></span>
                <ul class="plugin_log" v-if="showLog[3]">
                    <li>Ajout de fonction permettant de piloter la librairie depuis l’extension MerciApp.</li>
                    <li>Améliorations de l’affichage dans Studio de WoodWing.</li>
                    <li>Améliorations de l’intégration avec le Système de Design de l’État (<a href="https://github.com/GouvernementFR/dsfr" target="_blank">https://github.com/GouvernementFR/dsfr</a>).</li>
                </ul>
            </li>
            <li><a class="lienActif" href="https://www.prolexis.com/DIAGONAL/WebServicePlugin/InterfaceCorrectionWeb_4.0.8.zip" target="_blank" rel="noopener noreferrer">4.08</a> (version du 22-05-2025) <span @click='toggleLog(2)'><i class="material-icons pluginfo">info_outline</i></span>
                <ul class="plugin_log" v-if="showLog[2]">
                    <li>Augmentation du nombre de propositions de correction affichées.</li>
                    <li>La zone des explications s'affiche toujours en thème clair.</li>
                    <li>Prise en charge de l'imbrication de deux listes à puces.</li>
                    <li>Retrait de warnings sur FireFox.</li>
                    <li>Ajout du support de la clef d'API au proxy .NET.</li>
                </ul>
            </li>
            <li><a class="lienActif" href="https://www.prolexis.com/DIAGONAL/WebServicePlugin/InterfaceCorrectionWeb_4.0.7.zip" target="_blank" rel="noopener noreferrer">4.07</a> (version du 22-08-2024) <span @click='toggleLog(1)'><i class="material-icons pluginfo">info_outline</i></span>
                <ul class="plugin_log" v-if="showLog[1]">
                    <li>Nouvelle couleur pour afficher les anomalies de style.</li>
                    <li>Amélioration de l’affichage du numéro de version ProLexis WebService.</li>
                </ul>
            </li>
            <li><a class="lienActif" href="https://www.prolexis.com/DIAGONAL/WebServicePlugin/InterfaceCorrectionWeb_4.0.4.zip" target="_blank" rel="noopener noreferrer">4.04</a> (version du 5-07-2024) <span @click='toggleLog(0)'><i class="material-icons pluginfo">info_outline</i></span>
                <ul class="plugin_log" v-if="showLog[0]">
                    <li>Compatibilités TinyMce 6 et 7.</li>
                </ul>
            </li>
        </ul>

    </div>
</template>

<script>
    import FctUtils from '@/components/FctUtils';
    import { RoleEnum } from '../classes/enums';

    export default { 
        name:"Plugin",
        components: { },
        mixins: [FctUtils],
        data () {
            return {
                showLog: [],
                publicPath: process.env.BASE_URL
            }
        },
        computed:{
            role() {
                return this.$store.state.currentUser.role;
            }
        },
        methods : {
            isAdmin() {
                return this.role == RoleEnum.ADMIN.value || this.role == RoleEnum.SUPERADMIN.value
            },
            toggleLog(num) {
                this.showLog[num] = !this.showLog[num];
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.plugin_title {
    margin-top:20px
}

.plugin_log ul {
    margin-top:5px
}

.pluginfo {
    font-size: 18px;
    margin-left: 5px;
    color:#0075bb;
    vertical-align: text-bottom;

    cursor:pointer;
}

</style>
